module.exports = __webpack_public_path__ + "img/ski_sub_title5.e9c42a15.jpg";